export default __webpack_public_path__ + "static/media/guide32.c7b9c4fb.png";